export const navigation = {
  support: {
    question: "Precisa de ajuda?",
    whatsappCta: "Fale conosco pelo WhatsApp",
  },
  alt: {
    whatsapp: "Ícone do WhatsApp",
    logo: "Logo do painel",
  },
};
